<template>
  <div style="margin:20px">
    <div v-if="!standalone" style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <div class="vsm-page-header-row">
        <span class="vsm-page-header-title">Vehicle Maintenance Summary</span>
        <span class="vsm-page-header-actions">
          <vsm-history-link-button />&nbsp;
          <b-btn size="sm" variant="success" @click="view_more_info = !view_more_info" aria-label="more info"><i class="fa fa-info-circle"></i></b-btn>
        </span>
      </div>
      <div style="font-style: italic; font-size: 18px; padding-bottom: 15px; margin-right: 10px">this page shows the current maintenance status of vehicles</div>
    </div>

    <div v-if="standalone">
      <span style="font-size: 20px; font-weight: bold; margin-bottom: 10px;" class="d-flex align-items-center justify-content-center">
        <a target="_new" href="https://www.initekconsulting.com/fleet-integrations"><img style="margin-top:-5px" width="40" src="favicon.ico"/></a>&nbsp;Vehicle Maintenance Summary&nbsp;&nbsp;
        <b-spinner v-if="reloading" style="width: 1.8rem; height: 1.8rem"></b-spinner><span v-else style="width: 1.8rem; height: 1.8rem">&nbsp;</span>
          &nbsp;&nbsp;<b-btn size="sm" variant="success" @click="view_more_info = !view_more_info" aria-label="more info"><i class="fa fa-info-circle"></i></b-btn>
      </span>
    </div>


    <b-modal title="More Info" size="xl" v-model="view_more_info" ok-only>
      <br/>
      <h4>Vehicle Maintenance Summary</h4>
      <br><hr/>
      <h4>VSM Standalone Mode</h4>
      &nbsp;&nbsp;provides a standalone view that refreshes every minute
      <br/>&nbsp;&nbsp;<a target="_blank" :href="'./#/veh-maint-summary/' + standaloneId">click here to load the standalone</a><vsm-standalone-url-copy-button :href="'./#/veh-maint-summary/' + standaloneId" :tenant-id="tenant_id"/>
    </b-modal>

    <div v-if="!loading" style="margin: 20px;">
      <div class="row" style="margin: 10px; font-weight: bold; font-size: 24px;">
        <div class="col" style="border: 1px solid grey;">{{ items.length }} results</div>
        <b-btn size="sm" @click="load_data()"><b>reload</b></b-btn>
      </div>
    </div>

    <div v-if="summary">
      <b-table :busy="loading" sticky-header="70vh" bordered :items="items" :fields="fields"
               :current-page="currentPage" :style="'font-size:18px'" :per-page="perPage">

        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
          </div>
        </template>

        <template slot="issues" slot-scope="row">
          <span v-if="row.item.issues">
            {{row.item.issues.length}}
          </span>
        </template>

        <template slot="work_orders" slot-scope="row">
          <span v-if="row.item.work_orders">
            {{row.item.work_orders.length}}
          </span>
        </template>

        <template slot="estimated_completion_date" slot-scope="row">
          {{row.item.estimated_completion_date | formatDateTimeSmall}}
        </template>

        <template slot="days_past_due" slot-scope="row">
          <span v-if="row.item.estimated_completion_date">

          </span>
        </template>

        <template slot="details" slot-scope="row">
          <b-button size="sm" @click="row.toggleDetails">
            {{ row.detailsShowing ? '-' : '+' }}
          </b-button>
        </template>

        <template slot="row-details" slot-scope="row">
          <b-card style="text-align: left;">
            <span v-if="row.item.work_orders">
              <h3>Work Orders</h3>
              <table width="90%" cellspacing="2px" cellpadding="2px">
                <tr>
                  <th>WO#</th>
                  <th>Description</th>
                  <th>Status</th>
                  <th>Started</th>
                  <th>Expected Completion</th>
                </tr>
                <tr v-for="wo in row.item.work_orders">
                  <td>{{wo.number}}</td>
                  <td>{{wo.description}}</td>
                  <td>{{wo.status}}</td>
                  <td>{{wo.started_date | formatDateTimeSmall}}</td>
                  <td>{{wo.expected_completion_date | formatDateTimeSmall}}</td>
                </tr>
              </table>
              <br/>
            </span>

            <span v-if="row.item.issues">
              <h3>Issues</h3>
              <table width="90%" cellspacing="2px" cellpadding="2px">
                <tr>
                  <th>Name</th>
                  <th>Priority</th>
                  <th>Reported</th>
                  <th>Description</th>
                </tr>
                <tr v-for="issue in row.item.issues">
                  <td>{{issue.name}}</td>
                  <td>{{issue.priority}}</td>
                  <td>{{issue.reported_at | formatDateTimeSmall}}</td>
                  <td>{{issue.description}}</td>
                </tr>
              </table>
            </span>
          </b-card>
        </template>
      </b-table>
      <b-row v-if="items.length > 10">
        <b-col>
          <b-pagination
              v-model="currentPage"
              :total-rows="items.length"
              :per-page="perPage"
              align="center"
          >
          </b-pagination>
        </b-col>
      </b-row>
    </div>
    <div v-else>
      <div class="text-center text-danger my-2">
        <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
      </div>
    </div>
  </div>
</template>

<script>

import {get_vehicle_info, get_vehicle_maint_summary} from "../networking/apis";
import {mapState} from "vuex";
import moment from 'moment';
import datetime from 'vuejs-datetimepicker';
import {justDate} from "../helpers/dates";
import VsmStandaloneUrlCopyButton from './VsmStandaloneUrlCopyButton.vue'
import VsmHistoryLinkButton from './VsmHistoryLinkButton.vue'

export default {
  name: 'vehicle_maint_summary',
  components: {
     datetime,
     VsmStandaloneUrlCopyButton,
     VsmHistoryLinkButton,
  },
  metaInfo: {
    title: "Fleet Integrations",
    titleTemplate: "Fleet Integrations",
  },
  data() {
    return {
      standalone: false,
      view_more_info: false,
      search_filter: '',
      tenant_id: null,
      updating: false,
      reloading: false,
      details_fromDate: justDate(moment()),
      items: [],
      summary: null,
      loading: true,
      totalRows: 1,
      currentPage: 1,
      perPage: 300,
      pages: [],
      alert: {
        show: false,
        message: '',
        variant: ''
      },
      options: {
        format: 'MM-DD-YYYY',
        useCurrent: true,
        minDate: moment().subtract(30, 'days'),
        maxDate: moment().add(30, 'days'),
        keepOpen: false,
        showClear: true,
        showClose: true,
        toolbarPlacement: 'top',
      },
      fields: [
        { key: 'details', label: '', sortable: false, thStyle: { width: "20px" }},
        { key: 'vehicle', label: 'Vehicle', sortable: true, visible: true, thStyle: { width: "100px" }},
        { key: 'oos_date', label: 'OOS Date', sortable: true, visible: true, thStyle: { width: "100px" }},
        { key: 'estimated_completion_date', label: 'Est Completion Date', sortable: true, visible: true, thStyle: { width: "100px" }},
        { key: 'days_past_due', label: 'Days Past Due', sortable: true, visible: true, thStyle: { width: "100px" }},
        { key: 'issues', label: 'Open Issues', sortable: true, visible: true, thStyle: { width: "100px" }},
        { key: 'work_orders', label: 'Open Work Orders', sortable: true, visible: true, thStyle: { width: "100px" }},
      ],
    }
  },
  async created() {
    this.tenant_id = this.user.tenant
    this.fields_all = this.fields
    await this.check_features()
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    startTimer() {
      this.stopTimer()
      if (this.reload_mode > 0) {
        this.timer = setInterval(() => this.reload_data(), this.reload_mode)
      }
    },
    stopTimer() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    async resetTimerAndReload() {
      this.stopTimer()
      await this.reload_data()
      this.startTimer()
    },
    showAlert(msg, variant, autoclose) {
      this.alert.show = true
      this.alert.message = msg
      this.alert.variant = variant
      autoclose
          ? setTimeout(() => this.closeAlert(), autoclose)
          : null
    },
    closeAlert() {
      this.alert.show = false
      this.alert.message = ''
      this.alert.variant = ''
    },
    async check_features() {

      if (this.$route.path.indexOf('/veh-maint-summary/') != -1) {
        this.standalone = true
        this.tenant_id = this.$route.path.split('/veh-maint-summary/')[1]
        this.reload_mode = 60000
      }

      this.fields = this.fields_all
      this.load_data()
    },
    async load_data() {
      this.loading = true
      try {
        var results = await get_vehicle_maint_summary(this.tenant_id)
        const {value: { data = [] } } = results

        this.summary = data.summary
        moment.tz.setDefault(this.summary.timezone)
        this.items = data.results

        this.stopTimer()
        if (this.reload_mode > 0) {
          this.startTimer()
        }
      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, check your URL or contact support if needed', 'danger', 5000)
        this.stopTimer()
        this.loading = false
      }

      this.loading = false
    },
    async reload_data() {
      try {
        if (this.updating)
          return;

        if (this.$pageVisibility && this.$pageVisibility.hidden)
          return;

        if (this.reloading)
          return;

        this.reloading = true

        var results = await get_vehicle_maint_summary(this.tenant_id)
        const {value: { data = [] } } = results

        this.summary = data.summary
        moment.tz.setDefault(this.summary.timezone)
        this.items = data.results
      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.reloading = false
    },
    contains(val1, val2) {
      if (val1 != null) {
        return val1.toLowerCase().indexOf(val2.toLowerCase()) != -1;
      }
      return false;
    },
},
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
    standaloneId() {
      return (this.summary && this.summary.vsm_standalone_uuid) || this.tenant_id
    },
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.check_features()
      }
    },
    '$pageVisibility.hidden'(newVal, oldVal) {
      if (oldVal && !newVal) {
        this.resetTimerAndReload()
      }
    }
  }
}
</script>

<style scoped>
.total { border: 1px solid grey; border-radius: 5px; padding: 2px; margin:2px}

div.row:nth-child(even) {
  background-color: #f2f2f2;
}

tr:nth-child(even) {
  background-color: #f2f2f2;
}

.header {
  font-weight: bold;
}

div.col {
  border: 1px solid grey;
}

.table td {
  padding: .1rem !important;
}

.mvmt-table td {
  vertical-align: middle !important;
}

div.wrap {
  border: 1px solid grey;
  flex-wrap: wrap;
  display: flex;
  inline-size: 150px;
  /* overflow-wrap: break-word; */
}

.stats { border-radius: 5px; margin:2px}
</style>

